import { Component, OnInit, ViewChild } from '@angular/core';
import * as XLSX from 'xlsx';
import { Subject } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PartnerService } from '../../../../../services/partner.service';
import { ProductsService } from '../../../../../services/products.service';
import { HelpersService } from '../../../../../services/helpers.service';
import moment from 'moment';

@Component({
  selector: 'app-import-products',
  templateUrl: './import-products.component.html',
  styleUrls: ['./import-products.component.scss'],
})
export class ImportProductsComponent implements OnInit {
  public keys: string[];
  public dataSheet = new Subject();
  public data: any = [];
  public importData: any = [];
  public isExcelFile: boolean;
  public loading: boolean = false;
  public hasValidationErrors: boolean = false;
  public invalidFileFormat: boolean = false;
  public importing: boolean = false;
  public countryData: any = {};
  public progress: number = 0;
  public step = 1;
  public importSummary: any = {};

  @ViewChild('fileUpload') fileUpload: any;
  public columns: any = [
    {
      header: this.translate.instant('general.headers.sku'),
      field: 'SKU',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.name'),
      field: 'Name',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.brand'),
      field: 'Brand',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.type'),
      field: 'Type',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.barcodes'),
      field: 'BarcodeSummary',
      type: 'barcodeSummary',
    },
    {
      header: this.translate.instant('general.headers.taxable'),
      field: 'Taxable',
      type: 'boolean',
    },
    {
      header: this.translate.instant('general.headers.cost_price'),
      field: 'CostPrice',
      type: 'currency',
    },
    {
      header: this.translate.instant('general.headers.default_price'),
      field: 'DefaultPrice',
      type: 'currency',
    },
    {
      header: this.translate.instant('general.headers.status'),
      field: 'Status',
      type: 'status',
    },
  ];

  public columnsImported: any = [
    {
      header: this.translate.instant('general.headers.sku'),
      field: 'SKU',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.name'),
      field: 'Name',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.brand'),
      field: 'Brand',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.type'),
      field: 'Type',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.barcodes'),
      field: 'BarcodeSummary',
      type: 'barcodeSummary',
    },
    {
      header: this.translate.instant('general.headers.taxable'),
      field: 'Taxable',
      type: 'boolean',
    },
    {
      header: this.translate.instant('general.headers.cost_price'),
      field: 'CostPrice',
      type: 'currency',
    },
    {
      header: this.translate.instant('general.headers.default_price'),
      field: 'DefaultPrice',
      type: 'currency',
    },
    {
      header: this.translate.instant('general.headers.status'),
      type: 'status',
    },
  ];

  constructor(
    public router: Router,
    private translate: TranslateService,
    private partnerService: PartnerService,
    private helpersService: HelpersService,
    private productService: ProductsService,
  ) {}

  ngOnInit() {
    this.countryData = this.helpersService.getCountryData();
    console.log(this.countryData);
  }

  getProducts() {
    this.productService
      .getAllProductsWithGear(this.helpersService.getPartnerId())
      .subscribe((products) => {
        this.helpersService.saveProductData(products);
      });
  }

  prepareFile(evt) {
    let data, header;
    this.loading = true;
    const target: DataTransfer = <DataTransfer>evt.target;
    this.isExcelFile = !!target.files[0].name.match(/(.xls|.xlsx)/);
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      data = XLSX.utils.sheet_to_json(ws, { raw: false, defval: null });
    };

    reader.readAsBinaryString(target.files[0]);

    reader.onloadend = (e) => {
      this.keys = Object.keys(data[0]);
      this.dataSheet.next(data);
      this.processFile(data);
    };
    this.fileUpload.nativeElement.value = '';
  }

  processFile(data) {
    this.invalidFileFormat = false;
    this.hasValidationErrors = false;
    console.log(this.keys);
    console.log(data);
    if (
      this.keys.indexOf('SKU') > -1 &&
      this.keys.indexOf('Product Name') > -1 &&
      this.keys.indexOf('Default Price') > -1
    ) {
      this.step = 2;
      setTimeout(() => {
        this.processHubtigerTemplate(data);
      }, 250);
    } else {
      this.invalidFileFormat = true;
    }
  }

  processHubtigerTemplate(data) {
    var sheetData = [];
    data.forEach((row, index) => {
      var validation = this.validateRow(row);
      var valid = validation === 'Valid';

      if (row['Product Name'] !== 'Mandatory') {
        sheetData.push({
          SKU: row['SKU'] || null,
          Name: row['Product Name'] || null,
          Brand: row['Brand'] || '',
          Type: row['Product Type'] || '',
          ManufacturerSKU: row['Manufacturer SKU'] || '',
          EAN: row['EAN'] || '',
          UPC: row['UPC'] || '',
          BarcodeSummary:
            (row['Manufacturer SKU'] !== null &&
            row['Manufacturer SKU'] !== undefined
              ? '<li>' + row['Manufacturer SKU'] + '</li>'
              : '') +
            (row['EAN'] !== null && row['EAN'] !== undefined
              ? '<li>' + row['EAN'] + '</li>'
              : '') +
            (row['UPC'] !== null && row['UPC'] !== undefined
              ? '<li>' + row['UPC'] + '</li>'
              : ''),
          Taxable:
            row['Taxable'] && row['Taxable'].toLowerCase().trim() === 'yes'
              ? true
              : false,
          CostPrice: row['Cost Price'] || null,
          DefaultPrice: row['Default Price'] || null,
          Status: validation,
        });
        if (!valid) {
          this.hasValidationErrors = true;
        }
      }
    });

    this.data = sheetData;
    this.loading = false;
  }

  validateRow(row) {
    var message = '';
    if (
      row['Product Name'] === null ||
      row['Product Name'] === undefined ||
      row['Product Name'] === ''
    ) {
      message +=
        '<li>' +
        this.translate.instant(
          'bikeshop.pos_products.no_product_name_supplied',
        ) +
        '</li>';
    }
    if (
      row['Default Price'] === null ||
      row['Default Price'] === undefined ||
      row['Default Price'] === ''
    ) {
      message +=
        '<li>' +
        this.translate.instant(
          'bikeshop.pos_products.no_default_price_supplied',
        ) +
        '</li>';
    }

    return message === '' ? 'Valid' : message;
  }

  resetWizard() {
    this.invalidFileFormat = false;
    this.hasValidationErrors = false;
    this.keys = [];
    this.data = [];
    this.step = 1;
  }

  downloadTemplate() {
    window.open('/assets/excel-tempates/Product Import Template.xlsx');
  }

  beginImport() {
    this.importData = [];
    this.progress = 0;
    this.importing = true;
    this.loading = true;
    this.step = 3;

    setTimeout(() => {
      this.importData = this.data
        .filter((x) => {
          return x.Status === 'Valid';
        })
        .map((data, index) => {
          return { ...data, Index: index + 1, Status: null, Imported: null };
        });
      this.importSummary = {
        done: false,
        added: 0,
        updated: 0,
        errors: 0,
      };
      this.loading = false;
      this.pushDataToHubtiger();
    }, 250);
  }

  pushDataToHubtiger() {
    var data = {
      ImportedProducts: this.importData
        .filter((x) => {
          return x.Status === null;
        })
        .splice(0, 8),
      PartnerID: this.helpersService.getPartnerId(),
    };

    this.productService.importProducts(data).subscribe(
      (products) => {
        products.importedProductResult.forEach((product) => {
          var found = this.importData
            .filter((x) => x.Index === product.index)
            .pop();
          if (found !== null && found !== undefined) {
            found.SKU = product.sku;
            found.Imported = product.imported;
            found.Status = product.status;
          }
          if (product.status === 'New') {
            this.importSummary.added += 1;
          } else if (product.status === 'Updated') {
            this.importSummary.updated += 1;
          } else {
            this.importSummary.errors += 1;
          }
        });
        this.progress = Math.round(
          (this.importData.filter((x) => {
            return x.Status !== null;
          }).length /
            this.importData.length) *
            100,
        );

        if (
          this.importData.filter((x) => {
            return x.Status === null;
          }).length > 0
        ) {
          this.pushDataToHubtiger();
        } else {
          this.importSummary.done = true;
          this.importing = false;
          this.getProducts();
        }
      },
      (err) => {
        this.importing = false;
      },
    );
  }
}
